import AxiosConfig from '@/config/axios-config'
import * as Sentry from '@sentry/vue'

export const SalaAulaAPI = {

  obterTopico: function (curso, modulo, licao, topico) {
    return AxiosConfig.secureJalekoAPI().get(`/sala-de-aula/${curso}/${modulo}/${licao}/${topico}`, {
      params: {
        dataCancelamento: 1
      } }).then(response => response.data)
  },

  identificarTopico: function (curso, modulo, licao, topico) {
    let url = '/identificar-topico'
    if (curso) url += `/${curso}`
    if (modulo) url += `/${modulo}`
    if (licao) url += `/${licao}`
    if (topico) url += `/${topico}`

    return AxiosConfig.secureJalekoAPI().get(url).then(response => response.data)
  },

  obterTopicoUsuario: function (ementaId) {
    return AxiosConfig.secureJalekoAPI().get(`/topico_user/ementa/${ementaId}`).then(response => response.data)
  },

  atualizarVisualizacaoTopico: async function (ementaId, concluido) {
    try {
      let response = await AxiosConfig.secureJalekoAPI().put(`topico_user/ementa/${ementaId}`, { concluido: concluido })
      return response.data
    } catch (error) {
      Sentry.captureException(error, {
        tags: {
          referenceError: 'atualizarVisualizacaoTopico'
        }
      })
    }
  }

}

export default SalaAulaAPI
